import React, { useState, useRef } from 'react';
import Header from '../Header/Header';
import Footer from '../footer/Footer';
import { Link } from 'react-router-dom';
import { FiPlusCircle, FiVolume2, FiVolumeX, FiPause, FiPlay } from 'react-icons/fi';
import { motion } from 'framer-motion';
import './Home.css';
import ListeAnnonce from '../listeannonce/ListeAnnonce';
import Testimonials from '../testimonials/Testimonials';
import HowItWorks from '../how-it-works/HowItWorks';
import Mission from '../mission/Mission';
import Services from '../services/Services';
import CTA from '../cta/CTA';

const Home = () => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const [isVideoMuted, setIsVideoMuted] = useState(true);
  const videoRef = useRef(null);

  // Contrôle de la vidéo
  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isVideoPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsVideoPlaying(!isVideoPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isVideoMuted;
      setIsVideoMuted(!isVideoMuted);
    }
  };

  return (
    <div className="home-container">
      <Header />

      {/* Bannière principale avec vidéo - Côte d'Ivoire design */}
      <section className="hero-banner">
        {/* Flag stripes decoration */}
        <div className="hero-flag-stripes">
          <div className="stripe stripe-orange"></div>
          <div className="stripe stripe-white"></div>
          <div className="stripe stripe-green"></div>
        </div>

        {/* Floating decorative elements */}
        <div className="hero-float-elements">
          <div className="float-circle circle-1"></div>
          <div className="float-circle circle-2"></div>
          <div className="float-circle circle-3"></div>
        </div>

        <div className="hero-content-container">
          <div className="hero-text-content">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="hero-title"
            >
              Nous facilitons l'entraide et l'intégration des étudiants ivoiriens en France
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="hero-subtitle"
            >
              ETEF – Votre guide pour votre intégration et votre accompagnement tout au long de vos études en France
            </motion.p>
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="hero-cta"
            >
              <Link to="/ajouter-annonce" className="hero-btn primary">
                <FiPlusCircle className="icon" /> Déposer une annonce
              </Link>
              <Link to="/a-propos" className="hero-btn secondary">
                Découvrir nos services
              </Link>
            </motion.div>
          </div>
          
          {/* Conteneur vidéo + section évaluation */}
          <div className="hero-video-wrapper">
            <div className="hero-video-content">
              <video 
                ref={videoRef}
                autoPlay 
                muted={isVideoMuted}
                loop 
                playsInline
                className="hero-video"
              >
                <source src={require('../../assets/images/videoplayback.mp4')} type="video/mp4" />
                Votre navigateur ne supporte pas la vidéo.
              </video>
              
              {/* Badge vidéo */}
              <div className="video-badge">
                <span className="dot"></span>
                Vidéo de présentation
              </div>
              
              {/* Contrôles vidéo */}
              <div className="video-controls">
                <button 
                  className="video-control-btn"
                  onClick={togglePlayPause}
                  aria-label={isVideoPlaying ? "Mettre en pause" : "Lire la vidéo"}
                >
                  {isVideoPlaying ? <FiPause size={18} /> : <FiPlay size={18} />}
                </button>
                <button 
                  className="video-control-btn"
                  onClick={toggleMute}
                  aria-label={isVideoMuted ? "Activer le son" : "Désactiver le son"}
                >
                  {isVideoMuted ? <FiVolumeX size={18} /> : <FiVolume2 size={18} />}
                </button>
              </div>
              
              {/* Barre de progression */}
              <div className="video-progress">
                <div className="video-progress-bar" style={{ width: '0%' }}></div>
              </div>
            </div>

            {/* Section d'évaluation et profils - EN DESSOUS DE LA VIDÉO */}
            <div className="video-rating-section">
              <div className="rating-container">
                <div className="user-profiles">
                  <div className="profile-circle profile-1" style={{ background: '#f57c00' }}>
                    <span className="profile-initial">A</span>
                  </div>
                  <div className="profile-circle profile-2" style={{ background: '#e65100' }}>
                    <span className="profile-initial">B</span>
                  </div>
                  <div className="profile-circle profile-3" style={{ background: '#ffa726' }}>
                    <span className="profile-initial">C</span>
                  </div>
                  <div className="profile-circle profile-4" style={{ background: '#bf360c' }}>
                    <span className="profile-initial">D</span>
                  </div>
                  <div className="profile-circle profile-more">
                    <span>+42</span>
                  </div>
                </div>
                <div className="rating-stars">
                  <div className="stars">
                    <span className="star filled">★</span>
                    <span className="star filled">★</span>
                    <span className="star filled">★</span>
                    <span className="star filled">★</span>
                    <span className="star half">★</span>
                  </div>
                  <span className="rating-text">4.7 (128 avis)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wave-divider">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </section>

      <Mission />
      <Services />
      <ListeAnnonce />
      <HowItWorks />
      <Testimonials />
      <CTA />
      
      <Footer />
    </div>
  );
};

export default Home;